import StyledSelect from '../StyledSelect';
import TextareaAutosize from 'react-textarea-autosize';
import TextButton from '../TextButton';
import SVG from 'react-inlinesvg';
import { useAppStore } from '../../stores/appStore';
import { useContext, useLayoutEffect, useRef, useState } from 'react';
import { ReactSelectFocusManagerContext } from '../StyledSelect/ReactSelectFocusManager';

export default function AddElementGuidance({
  containerRef,
  guidanceRoleOptions,
  value,
  onChange,
  onKeyDown,
  roleSelectValue,
  onRoleSelectChange,
  handleRandomGenerate,
  onSubmit,
  disabled,
  className,
}) {
  const isMac = useAppStore((state) => state.isMac);
  const { focusElement, focusedElement } = useContext(ReactSelectFocusManagerContext);
  const selectRef = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const handleChange = (event) => {
    if (onRoleSelectChange) {
      onRoleSelectChange(event);
    }
  };

  const handleMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const handleMenuClosed = () => {
    setMenuIsOpen(false);
  };

  useLayoutEffect(() => {
    focusedElement.current = selectRef.current;
    focusElement();
  }, [focusElement, roleSelectValue, menuIsOpen]);

  return (
    <div
      ref={containerRef}
      className={"guidance" + (className ? ` ${className}` : "")}
    >
      <StyledSelect
        className="guidanceRoleSelect"
        options={guidanceRoleOptions}
        value={roleSelectValue}
        onChange={handleChange}
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClosed}
        ref={selectRef}
        aria-label="Select an element type for the generated entry"
      />
      <TextareaAutosize
        value={value}
        placeholder='Write custom instructions...&#10;e.g. "A cozy home library for my protagonist"'
        onChange={(e) => onChange(e.target.value)}
        autoFocus={true}
        onKeyDown={onKeyDown}
      />
      <div className="guidanceButtons">
        <TextButton
          className="randomCharacterButton"
          onClick={handleRandomGenerate}
          disabled={disabled}
          ariaLabel="Generate a random element"
        >
          <SVG
            src="/assets/dice.svg"
            aria-hidden="true"
          />
          Random Entry
        </TextButton>
        <button
          className="goButton"
          onClick={onSubmit}
          disabled={disabled}
          aria-label="Go"
        >
          Go
          <div
            className="keyboard-shortcut-container"
            aria-label={`Press ${isMac ? "command" : "control"} plus enter to generate`}
          >
            <SVG
              src={isMac ? "/assets/keyboard-shortcuts/command-key.svg" : "/assets/keyboard-shortcuts/control-key-pc.svg"}
              className="keyboard-shortcut"
              aria-hidden="true"
            />
            <SVG
              src="/assets/keyboard-shortcuts/enter-key.svg"
              className="keyboard-shortcut"
              aria-hidden="true"
            />
          </div>
        </button>
      </div>
    </div>
  );
}
